import { useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';

import { type FormRefs } from '@/sections/address/components/AddressForm';
import { focusAndScroll } from '@/sections/address/components/AddressForm/utils';
import type { AddressFormValues } from '@/sections/address/types/AddressFormValues';

export const useFormFieldRefs = (): FormRefs => {
  const formRefs = {
    regionRef: useRef<HTMLInputElement>(null),
    communeRef: useRef<HTMLInputElement>(null),
    streetNameRef: useRef<HTMLInputElement>(null),
    streetNumberRef: useRef<HTMLInputElement>(null),
    aliasRef: useRef<HTMLInputElement>(null)
  };

  const { formState } = useFormContext<AddressFormValues>();
  const { errors } = formState;

  useEffect(() => {
    if (errors.region) {
      focusAndScroll(formRefs.regionRef);
    } else if (errors.commune) {
      focusAndScroll(formRefs.communeRef);
    } else if (errors.streetName) {
      focusAndScroll(formRefs.streetNameRef);
    } else if (errors.streetNumber) {
      focusAndScroll(formRefs.streetNumberRef);
    } else if (errors.alias) {
      focusAndScroll(formRefs.aliasRef);
    }
  }, [
    errors,
    formRefs.aliasRef,
    formRefs.communeRef,
    formRefs.regionRef,
    formRefs.streetNameRef,
    formRefs.streetNumberRef
  ]);

  return formRefs;
};

export default useFormFieldRefs;
